<template>
    <div class="module">
        <header class="module__header">
            <router-link
                tag="a"
                class="back-btn"
                :to="{ name: 'super-permissions' }"
            >
                <span class="icon-chevron-left"></span>
            </router-link>
            <h1 class="has-back-btn">Edit Permission</h1>
        </header>

        <section class="module__body">
            <form
                class="full-width"
                @submit.prevent="updatePermission"
            >
                <div class="form-group">
                    <label for="name">Name</label>
                    <input
                        id="name"
                        v-model="name"
                        type="text"
                        required
                        maxlength="60"
                    />
                </div>

                <div class="form-group multi-select">
                    <multi-select-field
                        :allItems="allRoles"
                        label="Roles"
                        testId="roles-select"
                        :selectedValues="selectedRoleIdsArray"
                        @items-selected="handleRolesSelected"
                        @items-unselected="handleRolesUnselected"
                    ></multi-select-field>
                </div>

                <form-errors :response="errorResponse"></form-errors>

                <div class="form-group">
                    <button
                        type="submit"
                        class="btn btn-primary"
                        :class="{ active: submitted }"
                    >
                        <div>Update</div>
                    </button>
                </div>
            </form>
        </section>
    </div>
</template>

<script>
import FormErrors from '@/components/FormErrors.vue'
import canToast from '@/mixins/canToast'
import MultiSelectField from '@/components/MultiSelectField.vue'

export default {
    components: {
        FormErrors,
        MultiSelectField,
    },

    mixins: [canToast],

    data() {
        return {
            id: this.$route.params.id,
            name: null,
            allRoles: [],
            selectedRoleIds: new Set(),
            errorResponse: null,
            submitted: false,
        }
    },

    computed: {
        selectedRoleIdsArray() {
            return Array.from(this.selectedRoleIds)
        },
    },

    mounted() {
        this.$http.get(`permissions/${this.id}`).then(({ data }) => {
            this.name = data.name
            this.selectedRoleIds.clear()
            data.roles.forEach(({ id }) => this.selectedRoleIds.add(id))
        })

        this.$http.get('/roles/all').then(({ data }) => {
            this.allRoles = data.map(({ id, name }) => ({
                id,
                name,
            }))
        })
    },

    methods: {
        updatePermission() {
            this.submitted = true

            this.$http
                .put(`permissions/${this.id}`, {
                    name: this.name,
                    roles: this.selectedRoleIdsArray,
                })
                .then(() => {
                    this.toast('Permission successfully updated!')
                    this.$router.push('/permissions')
                })
                .catch((error) => {
                    this.errorResponse = error.response
                    this.submitted = false
                })
        },

        handleRolesSelected(ids) {
            ids.forEach((id) => {
                this.selectedRoleIds.add(id)
            })
        },
        handleRolesUnselected(ids) {
            ids.forEach((id) => {
                this.selectedRoleIds.delete(id)
            })
        },
    },
}
</script>
